import type shippingEn from "./shipping.en";

const shippingAr: Record<keyof typeof shippingEn, string> = {
  "settings.shipping": "الشحن والتوصيل",
  "settings.shipping_hint": "أسعار الشحن والتوصيل المحلي والاستلام من المتجر والطرود",
  "ship.title": "الشحن والتوصيل",
  "ship.test": "اختبر أسعار الشحن",
  "ship.test_run": "عرض الأسعار",
  "ship.test_hint": "شاهد ما سيُعرض على العميل عند الدفع لهذه المنتجات وهذا العنوان.",
  "ship.test_cart": "المنتجات",
  "ship.test_result": "يرى العملاء",
  "ship.add_products": "إضافة منتجات",
  "ship.cant_ship": "لا يمكن شحنه",
  "ship.country": "الدولة/المنطقة",
  "ship.qa_zone": "رقم المنطقة",
  "ship.zip": "الرمز البريدي",
  "ship.coordinates": "الموقع على الخريطة",
  "ship.coordinates_hint": "خط العرض وخط الطول، للتوصيل المحلي حسب المسافة أو المنطقة المرسومة.",
  "ship.no_shipping_needed": "لا شيء في هذه السلة يحتاج إلى شحن.",
  "ship.no_options": "لا يمكن للعملاء إتمام الطلب لهذا العنوان: لا يوجد سعر أو منطقة توصيل أو موقع استلام يغطيه.",
  "ship.delivery_minimum": "يصل التوصيل المحلي إلى هذا العنوان للطلبات من {amount}.",
  "ship.kind.shipping": "شحن",
  "ship.kind.local_delivery": "توصيل محلي",
  "ship.kind.pickup": "استلام",
  "ship.free": "مجاني",
  "ship.km_away": "على بعد {n} كم",
  "ship.nothing_set": "لا يمكن للعملاء إتمام الطلب بعد: أضف سعر شحن أو توصيلاً محلياً أو استلاماً من المتجر.",
  "ship.shipping": "الشحن",
  "ship.shipping_hint": "اختر إلى أين تشحن وكم تتقاضى. المنتجات ضمن الملف العام ما لم تنقلها إلى ملف مخصص.",
  "ship.create_profile": "إنشاء ملف مخصص",
  "ship.create_profile_hint": "تمنح الملفات المخصصة بعض المنتجات أسعاراً خاصة بها، مثل المنتجات الكبيرة أو القابلة للكسر.",
  "ship.create": "إنشاء",
  "ship.general": "أسعار الشحن العامة",
  "ship.general_products": "كل المنتجات غير الموجودة في ملفات أخرى ({n})",
  "ship.general_products_hint": "لتحديد أسعار مختلفة لمنتجات معينة، أضفها إلى ملف مخصص.",
  "ship.products_count": "{n} منتجات",
  "ship.custom_rates": "أسعار شحن مخصصة",
  "ship.no_zones": "لا توجد مناطق شحن",
  "ship.zones_summary": "{zones} · {n} أسعار",
  "ship.no_rates": "لا توجد أسعار",
  "ship.local_delivery": "التوصيل المحلي",
  "ship.local_delivery_hint": "وصّل الطلبات بنفسك إلى العملاء القريبين.",
  "ship.offers_delivery": "يقدّم التوصيل",
  "ship.no_delivery": "لا يقدّم التوصيل",
  "ship.pickup": "الاستلام من المتجر",
  "ship.pickup_hint": "دع العملاء يستلمون طلباتهم من مواقعك.",
  "ship.offers_pickup": "يقدّم الاستلام",
  "ship.no_pickup": "لا يقدّم الاستلام",
  "ship.packages": "الطرود",
  "ship.packages_hint": "الصناديق والأظرف التي تشحن بها، لملصقات الشحن.",
  "ship.add_package": "إضافة طرد",
  "ship.edit_package": "تعديل الطرد",
  "ship.no_packages": "لا توجد طرود بعد.",
  "ship.default": "افتراضي",
  "ship.delete_package": "حذف {name}؟",
  "ship.pkg.box": "صندوق",
  "ship.pkg.envelope": "ظرف",
  "ship.pkg.soft_package": "كيس مرن",
  "ship.pkg.length": "الطول",
  "ship.pkg.width": "العرض",
  "ship.pkg.height": "الارتفاع",
  "ship.pkg.unit": "الوحدة",
  "ship.pkg.weight": "الوزن فارغاً (كغ)",
  "ship.pkg.weight_hint": "يُضاف إلى وزن المنتجات في الملصقات.",
  "ship.pkg.name": "اسم الطرد",
  "ship.pkg.default": "استخدامه كطرد افتراضي",
  "ship.location_inactive": "هذا الموقع غير نشط. فعّله أولاً من الإعدادات ← المواقع.",
  "ship.pickup_enable": "يقدّم هذا الموقع الاستلام من المتجر",
  "ship.pickup_enable_hint": "يختاره العملاء عند الدفع ويأتون لاستلام طلباتهم.",
  "ship.ready_time": "وقت الاستلام المتوقع",
  "ship.ready_time_hint": "يظهر عند الدفع وفي تأكيد الطلب.",
  "ship.ready.1h": "جاهز عادةً خلال ساعة",
  "ship.ready.2h": "جاهز عادةً خلال ساعتين",
  "ship.ready.4h": "جاهز عادةً خلال 4 ساعات",
  "ship.ready.24h": "جاهز عادةً خلال 24 ساعة",
  "ship.ready.2d": "جاهز عادةً خلال 2–4 أيام",
  "ship.ready.5d": "جاهز عادةً خلال 5 أيام أو أكثر",
  "ship.pickup_instructions": "إشعار جاهزية الطلب للاستلام",
  "ship.pickup_instructions_hint": "تعليمات تُرسل في البريد، مثل مكان الوقوف أو ما يجب إحضاره.",
  "ship.profile_name": "اسم الملف",
  "ship.profile_name_hint": "لن يرى العملاء هذا الاسم.",
  "ship.profile_name_placeholder": "منتجات قابلة للكسر",
  "ship.products": "المنتجات",
  "ship.no_products": "لا توجد منتجات بعد. المنتجات التي تضيفها هنا تخرج من الملف العام.",
  "ship.variants_of": "{n} من {total} خيارات",
  "ship.group_n": "مجموعة المواقع {n}",
  "ship.shipping_rates": "أسعار الشحن",
  "ship.remove_group": "إزالة المجموعة",
  "ship.add_group": "إنشاء مجموعة مواقع جديدة",
  "ship.add_group_hint": "استخدم المجموعات عندما تشحن المواقع إلى أماكن مختلفة أو بأسعار مختلفة.",
  "ship.shipping_from": "الشحن من",
  "ship.shipping_to": "الشحن إلى",
  "ship.manage": "إدارة",
  "ship.no_locations": "اختر المواقع التي تشحن هذه المنتجات.",
  "ship.locations_hint": "تُجهَّز الطلبات من هذه المواقع بهذه الأسعار. يكون الموقع في مجموعة واحدة من الملف.",
  "ship.inactive": "غير نشط",
  "ship.in_other_group": "في مجموعة أخرى",
  "ship.create_zone": "إنشاء منطقة",
  "ship.edit_zone": "تعديل المنطقة",
  "ship.delete_zone_short": "حذف المنطقة",
  "ship.delete_zone": "حذف المنطقة {name}؟",
  "ship.delete_zone_body": "تُحذف أسعارها أيضاً عند الحفظ.",
  "ship.no_zones_hint": "أنشئ منطقة للدول والمناطق التي تشحن إليها.",
  "ship.zone_name": "اسم المنطقة",
  "ship.zone_name_hint": "لن يرى العملاء هذا الاسم.",
  "ship.selected_countries": "المحدد ({n})",
  "ship.search_countries": "ابحث عن الدول والمناطق",
  "ship.rest_of_world": "بقية العالم",
  "ship.in_other_zone": "في منطقة أخرى",
  "ship.all_regions": "كل المناطق",
  "ship.some_regions": "مناطق محددة ({label})",
  "ship.regions_n": "{n} مناطق",
  "ship.zone_no_rates": "لا توجد أسعار: لا يمكن للعملاء في هذه المنطقة إتمام الطلب.",
  "ship.rate_name": "اسم السعر",
  "ship.rate_name_hint": "يرى العملاء هذا عند الدفع.",
  "ship.condition": "الشرط",
  "ship.price": "السعر",
  "ship.price_hint": "أدخل 0 للشحن المجاني.",
  "ship.add_rate": "إضافة سعر",
  "ship.edit_rate": "تعديل السعر",
  "ship.cond_and_up": "{v} فأكثر",
  "ship.cond_up_to": "حتى {v}",
  "ship.free_over_short": "مجاني فوق {v}",
  "ship.transit_time": "مدة التوصيل",
  "ship.transit.custom": "مخصص (بدون مدة توصيل)",
  "ship.transit.economy": "من 5 إلى 8 أيام عمل",
  "ship.transit.standard": "من 3 إلى 4 أيام عمل",
  "ship.transit.express": "من يوم إلى يومي عمل",
  "ship.transit_name.economy": "اقتصادي",
  "ship.transit_name.standard": "عادي",
  "ship.transit_name.express": "سريع",
  "ship.delivery_promise": "وعد التوصيل",
  "ship.delivery_promise_hint": "مثال: في نفس اليوم إذا طُلب قبل الساعة 2 ظهراً",
  "ship.free_over_toggle": "مجاني عندما يبلغ الطلب مبلغاً معيناً",
  "ship.free_over": "مجاني للطلبات فوق",
  "ship.conditions": "الشروط",
  "ship.cond.flat": "بدون",
  "ship.cond.weight_based": "حسب وزن المنتجات",
  "ship.cond.price_based": "حسب سعر الطلب",
  "ship.min_price": "أدنى سعر",
  "ship.max_price": "أعلى سعر",
  "ship.min_weight": "أدنى وزن",
  "ship.max_weight": "أعلى وزن",
  "ship.no_limit": "بدون حد",
  "ship.delete_profile": "حذف {name}؟",
  "ship.delete_profile_body": "تعود منتجاته إلى الملف العام وتستخدم أسعاره.",
  "ship.delete_profile_button": "حذف الملف",
  "ship.local_delivery_for": "التوصيل المحلي: {name}",
  "ship.delivery_enable": "يقدّم هذا الموقع التوصيل المحلي",
  "ship.delivery_enable_hint": "يمكن للعملاء في مناطق التوصيل اختيار التوصيل المحلي عند الدفع.",
  "ship.delivery_area": "منطقة التوصيل",
  "ship.set_pin": "تحديد الموقع",
  "ship.move_pin": "تحريك الدبوس",
  "ship.pin_hint": "حدّد هذا الموقع على الخريطة للتوصيل حسب المسافة ولعرض بُعده للعملاء.",
  "ship.pin_mode": "انقر على الخريطة حيث يوجد هذا الموقع، أو اسحب الدبوس.",
  "ship.draw_mode": "انقر على الخريطة لإضافة زوايا {name}.",
  "ship.no_areas": "أضف المناطق التي توصّل إليها.",
  "ship.area.name": "اسم المنطقة",
  "ship.area.radius": "المسافة (كم)",
  "ship.area.polygon": "منطقة مرسومة",
  "ship.area.codes": "أرقام المناطق أو الرموز البريدية",
  "ship.area.codes_hint": "رموز بريدية مفصولة بفواصل. أضف * في النهاية للبادئة (مثل 100*).",
  "ship.area.default_radius": "ضمن {n} كم",
  "ship.area.default_polygon": "منطقة {n}",
  "ship.area.default_codes": "مناطق {n}",
  "ship.area.price": "سعر التوصيل",
  "ship.area.min_order": "الحد الأدنى للطلب",
  "ship.area.free_over": "مجاني فوق",
  "ship.area.points": "{n} نقاط",
  "ship.area.draw": "ارسم على الخريطة",
  "ship.area.undo": "تراجع عن نقطة",
  "ship.area.clear": "مسح",
  "ship.area.add_radius": "إضافة منطقة حسب المسافة",
  "ship.area.add_polygon": "رسم منطقة",
  "ship.area.add_codes": "إضافة مناطق / رموز بريدية",
  "ship.area.order_hint": "تُفحص المناطق بهذا الترتيب: تُستخدم أول منطقة تغطي العنوان (مع حدها الأدنى للطلب).",
  "ship.delivery_info": "معلومات التوصيل",
  "ship.checkout_instructions": "تعليمات الدفع",
  "ship.checkout_instructions_hint": "تظهر للعملاء الذين يختارون التوصيل المحلي.",
  "ship.schedule": "مواعيد وأوقات التوصيل",
  "ship.schedule_hint": "يختار العملاء موعداً عند الدفع. بدون مواعيد، لا يوجد اختيار للتاريخ.",
  "ship.slot.start": "من",
  "ship.slot.end": "إلى",
  "ship.slot.capacity": "عدد التوصيلات لكل موعد",
  "ship.slot.capacity_hint": "يُغلق الموعد عند امتلائه.",
  "ship.slot.add": "إضافة موعد",
  "ship.slot.none": "لا توجد مواعيد: لا يختار العملاء وقت التوصيل.",
  "ship.day.0": "الأحد",
  "ship.day.1": "الإثنين",
  "ship.day.2": "الثلاثاء",
  "ship.day.3": "الأربعاء",
  "ship.day.4": "الخميس",
  "ship.day.5": "الجمعة",
  "ship.day.6": "السبت",
  "ship.cutoff": "آخر موعد للتوصيل في نفس اليوم",
  "ship.cutoff_hint": "الطلبات بعد هذا الوقت لا تحصل على توصيل في نفس اليوم.",
  "ship.lead_days": "أيام التجهيز",
  "ship.lead_days_hint": "0 يسمح للعملاء باختيار اليوم.",
  "ship.days_ahead": "الأيام المتاحة للحجز",
  "ship.days_ahead_hint": "إلى أي مدى تظهر المواعيد مسبقاً.",
  "ship.blackout": "أيام بدون توصيل",
  "ship.blackout_hint": "العطل وأيام الإغلاق.",
  "ship.upcoming": "المواعيد القادمة",
};

export default shippingAr;
